export default {
	name: 'header',
	created () {
	},
	mounted () {
	},
	data () {
		return {
		}
	},
	methods: {
		gototHome(){
			this.$router.push({ name: "home" })
		}
	}
}


// WEBPACK FOOTER //
// ./src/pages/Shared/Header/header.script.js